// ----------------------------------------------------------------------------
// Snippet: Menu
// ----------------------------------------------------------------------------
// Entry point for menu styles (used by header and footer). No JS behavior.
// ----------------------------------------------------------------------------

import './_menu.scss';